angular
    .module('app')
    .component('statistics', {
        templateUrl: '/templates/pages/statistics/statistics.html',
        controller: 'StatisticsController',
        controllerAs: 'vm',
    });